export default __webpack_public_path__ + "static/media/profile2.7b2c4df9.webp";